module.exports = __webpack_public_path__ + "static/media/EducatorPayouts.03c72780.svg";